import { removeSpacingFromString } from "./removeSpacingFromString";

export const numberWithSpaces = (num: number | string) => {
  const numString =
    typeof num === "number" ? num.toString() : removeSpacingFromString(num);

  return numString.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
